import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-signature-form',
  templateUrl: './signature-form.component.html',
  styleUrl: './signature-form.component.css'
})
export class SignatureFormComponent{
  signatureStepForm!: FormGroup;
  selectUserType!:FormGroup;
  constructor(private formBuilder: FormBuilder) {

  }
  ngOnInit() {
    this.signatureStepForm = this.formBuilder.group({
        printedName: ['', Validators.required],
        understand : [false, Validators.required],
    });
 
}
}
